import Pencil from './Pencil'

export default Pencil
// eslint-disable-next-line import/export
export * from './Pencil'
